<template>
    <div class="full-width">
        <a class="a-text" :href="eshopopeeUrl" target="eshopopee">
            <div class="option-box" v-if="null != userInfoRef.acccompanycode">
                <div class="icon-span">
                    <font-awesome-icon icon="fa-solid fa-server" />
                </div>

                <div class="text-span" tkey="管理系統">
                    {{i18n.tkey("lang_manger_system")}}
                </div>
            </div>
        </a>

        <div class="option-box" @click="clickOperator" v-if="operatorFlag">
            <div class="icon-span">
                <font-awesome-icon icon="fa-solid fa-user-astronaut" />
            </div>

            <div class="text-span" tkey="營運員">
                {{i18n.tkey("lang_Operator_3d")}}
            </div>
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, computed, toRef, inject} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import myUtil from "@/util/util";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faServer } from '@fortawesome/free-solid-svg-icons'

    const { proxy } = getCurrentInstance()

    library.add(faServer)

    const userInfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")

    const { return3DOperatorFlag, call3DOperator } = inject('threeCityFunc', { return3DOperatorFlag: () => { return false }, call3DOperator: () => {} })
    const operatorFlag = ref(false)

    const eshopopeeUrl = computed(() => {
        const url = myUtil.generateEshopopeeManagerUrl(userInfoRef.value.acccompanycode, userInfoRef.value.login, userInfoRef.value.password)

        return url
    })

    // function goEShopopee() {
    //     myUtil.confirmWarning(i18n.tkey("lang_go_eshopopee_confirm_2"), () => {
    //         const url = myUtil.generateEshopopeeManagerUrl(userInfoRef.value.acccompanycode, userInfoRef.value.login, userInfoRef.value.password)
    //
    //         location.href = url
    //     })
    // }

    function clickOperator(){
        call3DOperator()
    }

    onMounted(() => {
        operatorFlag.value = return3DOperatorFlag()
    })
</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        text-align: center;
        user-select: none;
    }

    .icon-span {
        font-size: 20px;
    }

    .text-span {
        font-size: 12px;
    }

    .option-box {
        cursor: pointer;
    }
</style>